/* VH Pack Builder skin (sections/vh-pack-builder.liquid). VISUAL ONLY.
   1. Publishes --vh-pb-top on <html>: the bottom edge of the sticky site header (reward bar + header), read-only,
      written only when it changes. vh-pack-builder.css pins the builder's banner, cart and phone dock below it.
   2. Fly-to-pack: on Add / Add Max, a copy of the product photo arcs into the pack (desktop: the item's row in
      Your Pack; phones: its thumbnail in the top dock). The listener is passive and in the capture phase so it runs
      before the builder's own click handler, only to remember where the photo was; it never blocks or changes the
      click. It flies only after the builder has really added the item (the item's quantity in the pack went up).
   3. Phones: turns the builder's dock into a bottom bar and opens the builder's own pack panel (#bbg-drawer) as a sheet.
   It never touches the cart, storage, or any attribute or class of the builder's markup. */
(function () {
  'use strict';
  if (!document.getElementById('vh-pb')) return;
  var doc = document.documentElement;

  /* ---------- 1. sticky header edge ---------- */
  var lastTop = -1, queued = false;
  function measureTop() {
    queued = false;
    var b = 0;
    ['#retail-reward-bar', '.header-section'].forEach(function (s) {
      var el = document.querySelector(s);
      if (!el || !el.offsetParent && getComputedStyle(el).position !== 'fixed') return;
      var r = el.getBoundingClientRect();
      if (r.height > 0 && r.top < 4 + b) b = Math.max(b, r.bottom);
    });
    b = Math.max(0, Math.round(b));
    if (b !== lastTop) { lastTop = b; doc.style.setProperty('--vh-pb-top', b + 'px'); }
  }
  function queue() { if (!queued) { queued = true; requestAnimationFrame(measureTop); } }
  measureTop();
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue, { passive: true });
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(queue);
    ['#retail-reward-bar', '.header-section'].forEach(function (s) { var el = document.querySelector(s); if (el) ro.observe(el); });
  }

  /* ---------- first paint: cards rise in once ---------- */
  var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  if (!(reduce && reduce.matches)) {
    doc.classList.add('vh-pb-intro');
    setTimeout(function () { doc.classList.remove('vh-pb-intro'); }, 1600);
  }

  /* ---------- 2. fly-to-pack ---------- */
  var vis = function (r) { return r && r.width > 0 && r.height > 0; };
  var desktop = function () { return window.innerWidth >= 991; }; /* same switch as the builder */
  function esc(id) { return String(id).replace(/["\\]/g, '\\$&'); }
  function qtyOf(id) {
    var s = document.querySelector('#bbg-lines .bbg-line[data-variant-id="' + esc(id) + '"] .bbg-qty span');
    var n = s ? parseInt(s.textContent, 10) : 0;
    return isNaN(n) ? 0 : n;
  }
  function targetFor(id) {
    var el = null;
    if (desktop()) {
      el = document.querySelector('#bbg-lines .bbg-line[data-variant-id="' + esc(id) + '"] .l img');
      var lines = document.getElementById('bbg-lines'), r = el && el.getBoundingClientRect(), lr = lines && lines.getBoundingClientRect();
      if (!vis(r) || (lr && (r.bottom < lr.top || r.top > lr.bottom))) el = document.querySelector('#bbg-cart .bbg-cart-head h3');
    } else {
      el = document.querySelector('#bbg-mobile-combined .bbg-msc-total') || document.getElementById('bbg-mobile-combined');
    }
    return el && vis(el.getBoundingClientRect()) ? el : null;
  }
  function ring(x, y) {
    var r = document.createElement('div');
    r.className = 'vh-pb-ring'; r.setAttribute('aria-hidden', 'true');
    r.style.left = x + 'px'; r.style.top = y + 'px';
    document.body.appendChild(r);
    var done = function () { if (r.parentNode) r.parentNode.removeChild(r); };
    try {
      var a = r.animate([{ transform: 'scale(.3)', opacity: 1 }, { transform: 'scale(1.6)', opacity: 0 }], { duration: 520, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'forwards' });
      a.onfinish = done; a.oncancel = done;
    } catch (e) { done(); }
    setTimeout(done, 900);
  }
  function fly(src, from, target, delay) {
    var b = target.getBoundingClientRect();
    var c = document.createElement('img');
    c.src = src; c.alt = ''; c.setAttribute('aria-hidden', 'true'); c.className = 'vh-pb-flier';
    c.style.left = from.left + 'px'; c.style.top = from.top + 'px'; c.style.width = from.width + 'px'; c.style.height = from.height + 'px';
    document.body.appendChild(c);
    var vh = window.innerHeight || doc.clientHeight;
    var tx = b.left + b.width / 2, ty = Math.min(Math.max(b.top + b.height / 2, 24), vh - 24);
    var dx = tx - (from.left + from.width / 2), dy = ty - (from.top + from.height / 2);
    var sc = Math.max(0.12, Math.min(1, Math.max(b.width, 36) / Math.max(from.width, from.height)));
    var lift = Math.min(160, Math.max(60, Math.abs(dx) * 0.25)); /* arc height */
    var done = function () { if (c.parentNode) c.parentNode.removeChild(c); };
    try {
      var an = c.animate([
        { transform: 'translate(0,0) scale(1) rotate(0deg)', opacity: 1 },
        { transform: 'translate(' + dx * 0.45 + 'px,' + (dy * 0.45 - lift) + 'px) scale(' + (0.55 + sc * 0.45) + ') rotate(-10deg)', opacity: 1, offset: 0.45 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + sc + ') rotate(6deg)', opacity: 1, offset: 0.9 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(' + sc * 0.7 + ') rotate(6deg)', opacity: 0 }
      ], { duration: 820, delay: delay || 0, easing: 'cubic-bezier(.5,0,.3,1)', fill: 'both' });
      an.onfinish = function () {
        done();
        ring(tx, ty);
        try { if (target.animate) target.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.18)' }, { transform: 'scale(1)' }], { duration: 360, easing: 'ease-out' }); } catch (e) {}
        var bar = !desktop() && document.getElementById('bbg-mobile-combined');
        try { if (bar && bar.animate) bar.animate([{ boxShadow: '0 -18px 44px rgba(0,0,0,.5), 0 0 0 0 rgba(159,206,143,.5)' }, { boxShadow: '0 -18px 44px rgba(0,0,0,.5), 0 -6px 30px 2px rgba(159,206,143,.45)' }, { boxShadow: '0 -18px 44px rgba(0,0,0,.5), 0 0 0 0 rgba(159,206,143,0)' }], { duration: 600, easing: 'ease-out' }); } catch (e) {}
      };
      an.oncancel = done;
    } catch (err) { done(); return; }
    setTimeout(done, 2400);
  }
  document.addEventListener('click', function (e) {
    var t = e.target, btn = t && t.closest && t.closest('.bbg-section .bbg-add, .bbg-section .bbg-add-max');
    if (!btn || btn.disabled || (reduce && reduce.matches) || typeof Element.prototype.animate !== 'function') return;
    var id = btn.getAttribute('data-id'), card = btn.closest('.bbg-card'), img = card && card.querySelector('.bbg-img-wrap img');
    if (!id || !img) return;
    var from = img.getBoundingClientRect();
    if (!vis(from)) return;
    var src = img.currentSrc || img.src, before = qtyOf(id), tries = 0;
    var copies = btn.classList.contains('bbg-add-max') ? 3 : 1;
    (function check() { /* the builder adds synchronously; poll briefly in case a pop-up or a re-render intervenes */
      if (qtyOf(id) > before) {
        var target = targetFor(id);
        if (target) for (var i = 0; i < copies; i++) fly(src, from, target, i * 90);
        return;
      }
      if (++tries < 10) setTimeout(check, 40);
    })();
  }, { capture: true, passive: true });

  /* ---------- 3. phones: bottom pack bar + the builder's own pack sheet (#bbg-drawer) ----------
     Only toggles classes on <html> (vh-pb-open, vh-pb-off) and publishes --vh-pb-bar-h. The sheet's lines, totals and
     buttons are rendered and wired by the builder; nothing here clicks or changes them. */
  var bar = document.getElementById('bbg-mobile-combined');
  var drawer = document.getElementById('bbg-drawer');
  var section = document.querySelector('.bbg-section');
  if (bar && drawer && section) {
    var lastBarH = -1, barQueued = false;
    var open = function (on) {
      on = !!on && !desktop();
      doc.classList.toggle('vh-pb-open', on);
      if (on) measureBar();
    };
    var measureBar = function () {
      var h = desktop() ? 0 : Math.round(bar.getBoundingClientRect().height);
      if (h !== lastBarH) { lastBarH = h; doc.style.setProperty('--vh-pb-bar-h', h + 'px'); }
    };
    var place = function () { /* the bar rides along while the builder is on screen and slides away before the footer */
      barQueued = false;
      if (desktop()) { doc.classList.remove('vh-pb-off'); open(false); return; }
      var r = section.getBoundingClientRect(), vh = window.innerHeight || doc.clientHeight;
      var off = r.bottom < vh - 24 || r.top > vh - 40;
      if (off && doc.classList.contains('vh-pb-open')) off = false;
      doc.classList.toggle('vh-pb-off', off);
    };
    var queueBar = function () { if (!barQueued) { barQueued = true; requestAnimationFrame(place); } };
    measureBar(); place();
    if ('ResizeObserver' in window) { new ResizeObserver(measureBar).observe(bar); new ResizeObserver(queueBar).observe(section); } /* the builder renders the grid after us */
    window.addEventListener('load', queueBar);
    window.addEventListener('resize', function () { measureBar(); queueBar(); }, { passive: true });
    window.addEventListener('scroll', queueBar, { passive: true });
    bar.addEventListener('click', function (e) { /* tap the bar (not its buttons) to open / close the sheet */
      if (desktop() || (e.target.closest && e.target.closest('button,a,input'))) return;
      open(!doc.classList.contains('vh-pb-open'));
    });
    drawer.addEventListener('click', function (e) {
      if (e.target === drawer || (e.target.closest && e.target.closest('#bbg-close'))) open(false);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') open(false); });
    var head = drawer.querySelector('.bbg-drawer-head'), y0 = null; /* swipe the sheet's header down to close */
    if (head) {
      head.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; }, { passive: true });
      head.addEventListener('touchend', function (e) { if (y0 != null && e.changedTouches[0].clientY - y0 > 50) open(false); y0 = null; }, { passive: true });
    }
  }
})();
